
export default function AutomationsGridSuspense({ placeholder=9 }) {
  
  return (    
    <>
      {/* External Automations */}
      <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4 animate-pulse">        
        
        {[...Array(placeholder).keys()]?.map(item => (
          <div key={item} className="col-span-1 p-3  bg-white border border-gray-200 rounded-lg"
          >

            {/* Logos Block - source and apps */}
            <div className="flex space-x-3 relative overflow-hidden">                       

              {/* Apps Logos   */}
              <div className='flex border-gray-200 border rounded-md bg-white'>

                {[...Array(3).keys()]?.map(x => (                          
                  <div key={x} className="p-1  border-gray-150 border-r ">
                    <span className='inline-flex items-center justify-center bg-gray-200 h-10 w-10 rounded-md'>
                      <span className="text-white capitalize">
                    </span>
                  </span>  
                    {/* <AppLogo app={app} className='relative  inline-block h-10 w-10 rounded-md'/> */}
                  </div>
                ))}
              </div>
                    
            </div>

            {/* Description Block - name, etc */}
            <div className="mt-3">
              <p data-placeholder="" className="h-5 my-2 w-full bg-gray-200" />
              <p data-placeholder="" className="h-5 my-2 w-full bg-gray-200" />
              <p data-placeholder="" className="h-5 my-2 w-full bg-gray-200" />
            </div>
          </div>
        ))}

      </div>
    

    </>
  )
}
